import React, { useEffect, useState } from 'react'
import styles from './styles'
import {
  withStyles,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import { domainListAction } from 'src/reducers/domain/action'

const DEFAULT_SHARE_DOMAIN = process.env.REACT_APP_VIEW_URL?.replace(/^https?:\/\//, '').replace(/\/$/, '') || 'share.minicoursegenerator.com'

const MailCName = props => {
  const { entity, dispatch, classes, selectedDomain, setSelectedDomain } = props

  const [loading, setLoading] = useState(true)

  const [domains, setDomains] = useState([])
  const customDomain = useSelector(state => state.domain.list)
  const domainRawList = useSelector(state => state.domain.list.results)

  useEffect(() => {
    const queryDomainList = {
      CurrentPage: 0,
      PageSize: 200,
      SortingColumn: 'LastModifiedAt',
      Asc: false,
      FilterText: '',
      Filters: [],
    }

    if (customDomain.results != null) {
      setLoading(false)
      return
    }
    dispatch(
      domainListAction(queryDomainList, response => {
        setLoading(false)
      }),
    )
  }, [])

  useEffect(() => {
    if (domainRawList) {
      // Get all verified domains for the list
      const verifiedDomains = domainRawList.filter(
        item => item.verificationStatus === 1,
      )
      setDomains(verifiedDomains)

      // Find if there's a domain linked to this collection
      const collectionDomain = verifiedDomains.find(
        item =>
          item.defaultCollectionDto != null &&
          item.defaultCollectionDto.id === entity.id,
      )

      // If we found a domain linked to this collection, select it
      if (collectionDomain) {
        setSelectedDomain(collectionDomain.domain)
      }
    }
  }, [domainRawList, entity.id, customDomain])

  const handleSelect = event => {
    setSelectedDomain(event.target.value)

    /* const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(
        event.target.value,
        'customDomainId',
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(patchCollectionSettingsAction(patchSource, response => {})) */
  }
  return (
    <div className={classes.customDomain_select}>
      <div className={classes.displayF}>
        <Typography color="#637381" fontWeight={500} fontSize={'14px'}>
          Choose your custom domain linked to your collection
        </Typography>
      </div>

      <FormControl variant="outlined" className={classes.formControlHalf}>
        <InputLabel id="collection-setting-custom-domain">
          Custom Domain
        </InputLabel>
        <Select
          labelId="collection-setting-custom-domain"
          id="demo-simple-select-outlined"
          value={selectedDomain}
          label="Custom Domain"
          onChange={handleSelect}
          disabled={loading}
          sx={{ backgroundColor: '#ffffff', borderRadius: '6px' }}
        >
          <MenuItem value={DEFAULT_SHARE_DOMAIN}>
            (Default) {DEFAULT_SHARE_DOMAIN}
          </MenuItem>
          {domains.map(value => (
            <MenuItem value={value.domain} key={value.domain}>
              {value.domain}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default withStyles(styles)(MailCName)
